/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import Steps, { Step } from 'rc-steps';
import React from 'react';
import './WhiteListBanner.scss';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import { Button, Col, Modal, Nav, Row } from 'react-bootstrap';
import FaqLine from '../img/banner/faqline.png';
import RightArrow from '../img/LotteryBanner/arrow-right.png';

export default function WhiteListBanner(props) {
    const [currentStep, setCurrentStep] = React.useState(0);
    // const [walletAddress, setwalletAddress] = React.useState('');
    const [showWhitelistModel, setShowWhitelistModel] = React.useState(false);
    const [shown, setShown] = React.useState(false);
    const walletError = props.walletConnectError;

    const toggleBackdrop = () => {
        document.body.classList.toggle('remove-backdrop');
    };

    const Iframe = (props) => {
        return (
            <div>
                <iframe title={props.src} src={props.src} width="100%" />
            </div>
        );
    };
    return (
        <div className="banner-whitelist">
            <div className="container">
            <Row className="desktop-view">
                <Col>
                    <div className="wishlist-content">
                        <div className="white-list-title">
                            Apply for
                            <p className="title-whitelist">Whitelist</p>
                        </div>
                        <h6>
                            <span className="faqs">FAQs</span>
                            <span>
                                <img src={FaqLine} alt="line24" />
                            </span>
                            <span className="tcs">T&Cs</span>
                        </h6>
                        <p className="wishlist-banner-content">
                            * Users making any malicious attempts to increase the odds in their
                            favor unfairly will be disqualified
                        </p>
                    </div>
                </Col>
                <Col>
                    <div className="wishlist-stepper">
                        <Steps current={currentStep} direction="horizontal">
                            <Steps.Step className="step-1" />
                            <Steps.Step className="step-2" />
                            <Steps.Step className="step-3" />
                        </Steps>
                    </div>
                    {currentStep === 0 && (
                        <div>
                            <div className="wishlist-text">
                                <p className="wishlist-text__para-1">
                                    Connect your wallet for whitelisting by clicking
                                    <br /> the button below
                                </p>
                            </div>
                            <div className="wishlist_button-1">
                                <Button
                                    className="details-btn btn-transform connect-btn whitelist-shine whitelist-cont-btn"
                                    onClick={() => {
                                            props.connectToWallet();
                                            setCurrentStep(1);
                                        }}>
                                    Connect Wallet
                                    <span className="whitelist-hover-arrow"><img src={RightArrow} alt="right-arw" /></span>
                                </Button>
                            </div>
                        </div>
                    )}

                    {currentStep === 1 && (
                        <div>
                            <div className="proceed">
                                <h4 className="proceed__text-1">
                                    {!props.walletAddress ? "Getting your wallet address..." : ""}
                                </h4>
                            </div>
                            { props.walletAddress && <div className="copy-text">
                                <span className="copy-text-key">
                                    {props.walletAddress}
                                </span>
                                {/* <Button
                                    className="copy-text-btn"
                                    onClick={() => setwalletAddress(true)}>
                                    Copy
                                </Button> */}
                            </div> }
                            <div>
                                <Button
                                    disabled={!props.walletAddress}
                                    className="proceed-btn shine"
                                    onClick={() => setCurrentStep(2)}>
                                    Proceed
                                </Button>
                            </div>
                            {/* <div>
                                <p className="copied-address">
                                    {walletAddressCopied && <p>Wallet address copied to clipboard!</p>}
                                </p>
                            </div> */}
                        </div>
                    )}

                    {currentStep === 2 && (
                        <div>
                            <div>
                                <p className="details-text">
                                    Please fill in additional details required by clicking on the
                                    button below.
                                </p>
                            </div>
                            <div>
                                <Button
                                    className="btn-step-3 btn-transform detail-btn shine"
                                    onClick={() => {
                                        toggleBackdrop();
                                        setShowWhitelistModel(true);
                                        setShown(true);
                                    }}>
                                    Enter Details
                                </Button>
                            </div>
                        </div>
                    )}
                </Col>
            </Row>

            {/* Whitelist component in mobile view */}
            <Row className="whitelist-mobile">
                <div>
                    Whitelisting registration is
                    <br />
                    supported only on Desktop
                </div>
            </Row>
            </div>

            {/* wishlist model */}
            <>
                <Modal
                    show={showWhitelistModel}
                    size="lg"
                    onHide={() => setShowWhitelistModel(false)}
                    dialogClassName="modal-90w"
                    animation={false}
                    className="whitelist-modal"
                    aria-labelledby="example-custom-modal-styling-title">
                    <Modal.Header closeButton onClick={toggleBackdrop} />
                    <Modal.Body>
                        <div className="whitelist-frame">
                            {shown ? (
                                <Iframe src={`https://form.jotform.com/211402610503436?yourSolana39=${props.walletAddress}`} />
                            ) : null}
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        </div>
    );
}
